module.exports = __webpack_public_path__ + "static/media/java.13a09653.svg";